import { Pipe, PipeTransform } from '@angular/core';
import { FeUtil } from '../../hezky-routes';
import { DateTime } from 'luxon';

@Pipe({
  name: 'gDate',
})
export class GlobalDatePipe implements PipeTransform {
  constructor(private readonly feUtil: FeUtil) { }

  transform(value: Date | string | number | null, format = 'MMM dd yyyy, HH:mm a'): string {
    if (value == null) return 'N/A';
    let luxonDate: DateTime | null = null;
    if (typeof value === 'number') {
      luxonDate = DateTime.fromMillis(value, { zone: this.feUtil.time_zone });
    } else if (typeof value === 'string') {
      luxonDate = DateTime.fromISO(value, { zone: this.feUtil.time_zone });
      if (!luxonDate.isValid) {
        luxonDate = DateTime.fromRFC2822(value, { zone: this.feUtil.time_zone });
      }
      if (!luxonDate.isValid) {
        luxonDate = DateTime.fromSQL(value, { zone: this.feUtil.time_zone });
      }
      if (!luxonDate.isValid) {
        const jsDate = new Date(value);
        if (!isNaN(jsDate.getTime())) {
          luxonDate = DateTime.fromJSDate(jsDate, { zone: this.feUtil.time_zone });
        }
      }
    } else if (value instanceof Date) {
      luxonDate = DateTime.fromJSDate(value, { zone: this.feUtil.time_zone });
    }
    if (!luxonDate || !luxonDate.isValid) return 'Invalid Date';
    try {
      return luxonDate.toFormat(format);
    } catch {
      return luxonDate.toISO() || 'Invalid Date';
    }
  }
}